import { render, staticRenderFns } from "./TapOff.vue?vue&type=template&id=2a2a095c&scoped=true&"
import script from "./TapOff.vue?vue&type=script&lang=js&"
export * from "./TapOff.vue?vue&type=script&lang=js&"
import style0 from "./TapOff.vue?vue&type=style&index=0&id=2a2a095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a095c",
  null
  
)

export default component.exports